import { NotificationTypeId } from './constants/notification-types';
import LikeArticleNotification from './types/LikeArticleNotification';
import LikeCommentNotification from './types/LikeCommentNotification';
import FollowNotification from './types/FollowNotification';
import InvestmentNotification from './types/InvestmentNotification';
import ReputationNotification from './types/ReputationNotification';
import ModerationFlaggedNotification from './types/ModerationFlaggedNotification';
import ModerationModeratedNotification from './types/ModerationModeratedNotification';
import DefaultNotification from './types/DefaultNotification';
import NewsletterCommentNotification from './types/NewsletterCommentNotification';
import NewsletterCommentReplyNotification from './types/NewsletterCommentReplyNotification';
import NewsletterCommentMentionNotification from './types/NewsletterCommentMentionNotification';
import NewsletterArticleMentionNotification from './types/NewsletterArticleMentionNotification';
import ArticleMileStone1000Notification from './types/ArticleMileStone1000Notification';
import CreateResponseNotification from './types/CreateResponseNotification';
import UpdateResponseNotification from './types/UpdateResponseNotification';

/**
 * Factory component that renders the appropriate notification type
 * based on notificationTypeId
 */
const NotificationTypeRenderer = ({ notification, displayName, subIcon }) => {
  const typeId = notification.notificationTypeId;

  switch (typeId) {
    // Comment-related notifications
    case NotificationTypeId.NEWSLETTER_ARTICLE_COMMENT:
      return <NewsletterCommentNotification notification={notification} />;
    case NotificationTypeId.NEWSLETTER_ARTICLE_SECTION_COMMENT:
      return <NewsletterCommentNotification notification={notification} />;
    case NotificationTypeId.NEWSLETTER_COMMENT_REPLY:
      return <NewsletterCommentReplyNotification notification={notification} />;

    // Like-related notifications
    case NotificationTypeId.NEWSLETTER_ARTICLE_LIKE:
      return <LikeArticleNotification notification={notification} />;
    case NotificationTypeId.NEWSLETTER_COMMENT_LIKE:
      return <LikeCommentNotification notification={notification} />;

    // Mention notifications
    case NotificationTypeId.NEWSLETTER_COMMENT_MENTION:
      return <NewsletterCommentMentionNotification notification={notification} />;
    case NotificationTypeId.NEWSLETTER_ARTICLE_MENTION:
      return <NewsletterArticleMentionNotification notification={notification} />;

    // Follow notifications
    case NotificationTypeId.NEWSLETTER_USER_FOLLOW:
      return <FollowNotification notification={notification} />;

    // Moderation notifications
    case NotificationTypeId.NEWSLETTER_CONTENT_FLAGGED:
      return <ModerationFlaggedNotification notification={notification} />;
    case NotificationTypeId.NEWSLETTER_CONTENT_MODERATED:
      return <ModerationModeratedNotification notification={notification} />;

    case NotificationTypeId.ARTICLE_MILESTONE_1000:
      return <ArticleMileStone1000Notification notification={notification} />;

    // Review notifications
    case NotificationTypeId.NEWSLETTER_CREATE_RESPONSE:
      return <CreateResponseNotification notification={notification} />;
    case NotificationTypeId.NEWSLETTER_UPDATE_RESPONSE:
      return <UpdateResponseNotification notification={notification} />;

    case NotificationTypeId.NEWSLETTER_ARTICLE_INVESTMENT:
      return <InvestmentNotification notification={notification} />;

    case NotificationTypeId.NEWSLETTER_REPUTATION_POINTS:
      return <ReputationNotification notification={notification} />;

    case NotificationTypeId.CREATOR_PAYOUT_THRESHOLD:
    case NotificationTypeId.CREATOR_PAYOUT_SUCCESS:
    default:
      return (
        <DefaultNotification
          notification={notification}
          displayName={displayName}
          subIcon={subIcon}
        />
      );
  }
};

export default NotificationTypeRenderer;
